import { toastController, ToastOptions } from "@ionic/vue";

export async function sendToast(
	message: string,
	duration?: number,
	color?: string,
	options?: ToastOptions,
) {
	const toast = await toastController.create({
		message,
		duration: duration ?? 2000,
		color: color ?? "primary",
		...(options ?? {}),
	});
	await toast.present();
}
